<script setup lang="ts">
import helpers from '@utils/helpers';
import { onMounted, ref } from 'vue';
import type { ParamsCallback } from '../../utils/global-types';
import { useModalStore } from "./modal-store";

const props = defineProps<{
    title: string,
    notes: string,
    limit?: number,
    close: ParamsCallback
}>();

onMounted(() => helpers.focusElement(props.limit ? 'limit-notes' : 'no-limit-notes'))

const modal = useModalStore();
const note = ref(props.notes);
const requestPending = ref(false);

function save() {
    requestPending.value = true;
    props.close(note.value);
}
</script>
<template>
    <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" @click="modal.cancel" aria-hidden="true"><i
                class="fas fa-times"></i></button>
        <h4 class="modal-title">
            {{ title }}
            <small v-if="limit">(max. {{ limit }} characters)</small>
        </h4>
    </div>
    <div class="modal-body">
        <textarea id="limit-notes" v-if="limit" class="form-control" rows="5" v-model="note"
            :maxlength="limit"></textarea>
        <textarea id="no-limit-notes" v-if="!limit" class="form-control" rows="5" v-model="note"></textarea>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default" @click="modal.cancel">Cancel</button>
        <button class="btn btn-primary" @click="save" :disabled="requestPending">Save Notes</button>
    </div>
</template>